import { createFileRoute } from "@tanstack/react-router";
import { AssetGroupDescriptionBox } from "@/components/Map/components/AssetGroupDescriptionBox";

export const Route = createFileRoute("/_auth/kart/assetGroup/$assetGroupName")({
  component: AssetGroupDescriptionBox,
});
